export const MINIMUM_HOURLY_RATE_WARNING =
  'This rate is below the company minimum. Update it before activating this associate.'

export const MINIMUM_SALARY_WARNING =
  'This salary is below the company minimum. Update it before activating this associate.'

export function getProjectPaymentSettings(projectOrSettings) {
  return projectOrSettings?.payment_settings ?? projectOrSettings ?? {}
}

function isFiniteNumber(value) {
  if (value === undefined || value === null || value === '') {
    return false
  }

  return Number.isFinite(Number(value))
}

export function isCentPayBelowDollarMinimum(payValue, minimumValue) {
  if (!isFiniteNumber(payValue) || !isFiniteNumber(minimumValue)) {
    return false
  }

  const minimumInCents = Number(minimumValue) * 100

  return minimumInCents > 0 && Number(payValue) < minimumInCents
}

export function isHourlyRateBelowMinimum(paymentInfo, paymentSettings) {
  if (!paymentInfo || paymentInfo.type === 'Volunteer') {
    return false
  }

  return isCentPayBelowDollarMinimum(paymentInfo.hourly_rate, paymentSettings?.minimal_hour_rate)
}

export function isSalaryBelowMinimum(paymentInfo, paymentSettings) {
  if (!paymentInfo || paymentInfo.type === 'Volunteer' || paymentInfo.method !== 'salary') {
    return false
  }

  return isCentPayBelowDollarMinimum(paymentInfo.salary, paymentSettings?.minimal_salary)
}

export function getMinimumPayWarnings(paymentInfo, projectOrSettings) {
  const paymentSettings = getProjectPaymentSettings(projectOrSettings)

  return {
    hourly_rate: isHourlyRateBelowMinimum(paymentInfo, paymentSettings) ? MINIMUM_HOURLY_RATE_WARNING : '',
    salary: isSalaryBelowMinimum(paymentInfo, paymentSettings) ? MINIMUM_SALARY_WARNING : ''
  }
}

export function getMinimumPayActivationFields(paymentInfo, projectOrSettings) {
  const warnings = getMinimumPayWarnings(paymentInfo, projectOrSettings)
  const fields = []

  if (warnings.hourly_rate) {
    fields.push('hourly rate')
  }

  if (warnings.salary) {
    fields.push('salary')
  }

  return fields
}

export function getMinimumPayActivationMessage(fields) {
  if (fields.length === 1) {
    return `Update the associate ${fields[0]} before activating or reactivating this associate.`
  }

  return 'Update the associate hourly rate and salary before activating or reactivating this associate.'
}
